module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/new-transfer/new-transfer.component.css
// module id = ./src/app/new-transfer/new-transfer.component.css
// module chunks = main